import { motion } from "framer-motion";
import { EyeOff, Lock, ShieldCheck } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  { n: "01", icon: EyeOff, title: "We store nothing personal", text: "Only your payment status — paid or canceled. That's it. Not even the developer sees your details." },
  { n: "02", icon: Lock, title: "Never for sale. At any price.", text: "Your info is not a product. Payments are handled entirely by Stripe — card data never touches our servers." },
  { n: "03", icon: ShieldCheck, title: "Pay, unlock, done", text: "The moment your payment clears, your upgrade is live. Cancel anytime. No questions, no dark patterns." },
];

export const Manifesto = () => (
  <section data-testid="privacy-section" className="border-t border-border/60">
    <div className="max-w-6xl mx-auto px-6 py-28">
      <motion.p
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="font-mono text-xs uppercase tracking-[0.35em] text-accent mb-5"
      >
        Chapter 03 — The Privacy Manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        transition={{ duration: 0.8, ease: EASE }}
        className="font-heading text-3xl sm:text-4xl tracking-tight font-medium max-w-2xl"
      >
        Pay, unlock, done. We keep <span className="text-accent">zero</span> of your personal data.
      </motion.h2>

      <div className="mt-16">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
            className={`grid md:grid-cols-[140px_1fr] gap-6 py-12 border-b border-border/40 ${i % 2 ? "md:pl-24" : ""}`}
          >
            <span className="font-heading text-6xl sm:text-7xl font-light text-muted-foreground/30 leading-none">{c.n}</span>
            <div className="flex flex-col gap-3 max-w-xl">
              <c.icon className="w-6 h-6 text-accent" />
              <h3 className="font-heading text-xl sm:text-2xl tracking-tight font-medium">{c.title}</h3>
              <p className="text-base leading-relaxed text-muted-foreground">{c.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
